import {
    RaikoBaseDialogContentContainer, RaikoGridOneColumn,
    RaikoMoneyInputOutlined, RaikoNumberInputOutlined,
    RaikoSectionContainer, RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {ProductVariantService} from "../../../serverService/productVariantService/ProductVariantService";

export default function AddNewVariant({productId, handleCloseVariantDialog, handleAddNewVariant}) {

    const [variantTitle, setVariantTitle] = useState("");
    const [price, setPrice] = useState("");
    const [compareAtPrice, setCompareAtPrice] = useState("");
    const [actionButtonLoading, setActionButtonLoading] = useState(false);
    const service = new ProductVariantService()


    function handleCreateNewVariant() {
        setActionButtonLoading(true)
        service.addNewVariant(productId, variantTitle, price, compareAtPrice)
            .then(response => {
                handleCloseVariantDialog()
                handleAddNewVariant(response)
                showSuccessMessage("نوع جدید با موفقیت افزوده شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن نوع جدید"}
                hasActionButton
                actionButtonTitle={"افزودن"}
                actionButtonLoadingState={actionButtonLoading}
                actionButtonOnclickWithValidation={handleCreateNewVariant}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseVariantDialog}
            >
                <RaikoGridOneColumn>
                    <RaikoSimpleInputOutlined
                        labelText={"عنوان"}
                        value={variantTitle}
                        setValue={setVariantTitle}
                        required
                    />
                    <RaikoMoneyInputOutlined
                        labelText={"قیمت"}
                        value={price}
                        setValue={setPrice}
                        required
                    />
                    <RaikoMoneyInputOutlined
                        labelText={"قیمت تخفیف"}
                        value={compareAtPrice}
                        setValue={setCompareAtPrice}
                        required
                    />
                </RaikoGridOneColumn>

            </RaikoSectionContainer>
        </RaikoBaseDialogContentContainer>
    )
}